<template>
  <v-app>

    <v-navigation-drawer fixed :clipped="$vuetify.breakpoint.mdAndUp" app v-model="drawer">
      <v-list dense>
        <template v-for="(item, index) in items">
          <v-layout row v-if="item.heading" align-center :key="item.heading">
            <v-flex xs6>
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group v-else-if="item.children" v-model="item.model" :key="item.text"
            :prepend-icon="item.model ? item.icon : item['icon-alt']" append-icon>
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile :to="child.to" v-for="(child, i) in item.children" :key="i">
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  <v-list-tile-title>{{ child.text }}</v-list-tile-title>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :to="item.to" :key="index">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-progress-linear v-if="this.$store.state.progress" color="deep-purple" indeterminate height="6"
      style="position: fixed; top: 50px; z-index: 99999"></v-progress-linear>
    <v-toolbar color="amber" app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span class="hidden-sm-and-down">{{ currentUser.firstName }}</span>
      </v-toolbar-title>

      <div class="gold-price-widget" :class="{ 'gold-price-stale': isGoldPriceStale }" v-if="goldPrice !== null">
        <v-icon small class="gold-price-icon">monetization_on</v-icon>
        <div class="gold-price-body">
          <span class="gold-price-label">Has Altın</span>
          <span class="gold-price-value">{{ formatGoldPrice(goldPrice) }} ₺</span>
          <span class="gold-price-updated" v-if="goldPriceModifiedDate">{{ formatUpdated(goldPriceModifiedDate) }}</span>
        </div>
      </div>

      <!-- Tenant/Marketplace Selector'ı toolbar'da ekle -->
      <div style="display: flex; gap: 10px; margin-left: 20px; margin-right: 20px;"
        v-if="currentUser && currentUser.tenantOptions">
        <v-select v-model="selectedTenant" :items="tenantOptions" item-text="tenantName" item-value="tenantId"
          label="Ürün" @change="onTenantChange" outlined dense hide-details
          style="min-width: 150px; margin-top: 8px;"></v-select>
        <v-select v-model="selectedMarketplace" :items="filteredMarketplaceOptions" item-text="mpName" item-value="mpId"
          label="MarketPlace" @change="onMarketplaceChange" outlined dense hide-details
          style="min-width: 150px; margin-top: 8px;" :disabled="!selectedTenant"></v-select>
      </div>

      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>apps</v-icon>
      </v-btn>
      <mint-notification-bell />
      <v-btn icon large @click="logout">
        <v-avatar size="32px" tile>
          <img src="@/assets/logo.svg" alt="Vuetify" />
        </v-avatar>
      </v-btn>

    </v-toolbar>

    <v-content>
      <router-view />
    </v-content>
    <v-dialog v-model="$store.state.dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Bilgilendirme</v-card-title>
        <v-card-text>{{ $store.state.message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" dark depressed @click="$store.state.dialog = false">Tamam</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import { authenticationService } from "@/_services";
import goldPriceApi from "@/api/goldPrice";
import MintNotificationBell from "@/components/MintNotificationBell.vue";

export default {
  components: { MintNotificationBell },
  data() {
    return {
      currentUser: null,
      message: null,
      drawer: null,
      selectedTenant: null,
      selectedMarketplace: null,
      tenantOptions: [],
      marketplaceOptions: [],
      allTenantMarketplaces: [], // Tüm tenant-marketplace kombinasyonları
      goldPrice: null,
      goldPriceModifiedDate: null,
      goldPriceTimer: null,
      goldPriceStaleTick: Date.now(),
      goldPriceStaleTimer: null,
    };
  },
  props: {
    source: String,
  },
  computed: {
    isAdmin() {
      return this.currentUser && this.currentUser.isAdmin;
    },
    isGoldPriceStale() {
      if (!this.goldPriceModifiedDate) return false;
      const modifiedTs = new Date(this.goldPriceModifiedDate).getTime();
      if (Number.isNaN(modifiedTs)) return false;
      return this.goldPriceStaleTick - modifiedTs > 30 * 60 * 1000;
    },
    filteredMarketplaceOptions() {
      if (!this.selectedTenant || !this.allTenantMarketplaces) {
        return [];
      }

      // Seçili tenant'a ait marketplace'leri filtrele
      return this.allTenantMarketplaces
        .filter(item => item.tenantId === this.selectedTenant)
        .map(item => ({ mpId: item.mpId, mpName: item.mpName }))
        .filter((item, index, self) =>
          index === self.findIndex(t => t.mpId === item.mpId)
        ); // Unique marketplace'ler
    },
    items() {
      return [
        { icon: "dashboard", text: "Ana Sayfa", to: "/" },
        { icon: "insert_chart", text: "Modern Dashboard", to: "/modern-dashboard" },
        { icon: "assessment", text: "Rapor", to: "/report" },
        ...(this.selectedTenant === 2
          ? [{ icon:"shopping_cart", text: "Genişletilmiş Sipariş", to: "/rich-order" }]
          : [{ icon:"shopping_cart", text: "Siparişler", to: "/order" }]),
        // {
        //   icon: "keyboard_arrow_up",
        //   "icon-alt": "keyboard_arrow_down",
        //   text: "Sipariş",
        //   model: false,
        //   children: [
        //     { text: "Siparişler", to: "/order" },
        //     ...(this.selectedTenant === 2 ? [{ text: "Genişletilmiş Sipariş", to: "/rich-order" }] : [])
        //   ]
        // },
        { icon: "history", text: "Stok", to: "/stock" },
        { icon: "contacts", text: "Ödemeler", to: "/payment" },
        ...(this.selectedTenant === 2
          ? [{ icon: "account_balance", text: "Anlaşmalı Bankalar", to: "/partner-banks" }]
          : []),
        { icon: "compare_arrows", text: "Mutabakat", to: "/reconciliation" },
        ...(this.selectedTenant === 1
          ? [{ icon: "handshake", text: "Darphane Anlaşmaları", to: "/mint-agreements" }]
          : []),
        { icon: "table_chart", text: "Maliyet Tablosu", to: "/cost-table" },
        { icon: "local_shipping", text: "Kargo Süresi", to: "/dispatch-time" },
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "Ürün",
          model: true,
          children: [
            { icon: "add", text: "MP Ürün Listele", to: "/mpproduct" },
            { icon: "add", text: "MP Ürün Ekle", to: "/mpproduct/detail" },
            { icon: "add", text: "Stok Grup Listele ", to: "/stockGroup" },
            { icon: "add", text: "Stok Grup Ekle", to: "/stockGroup/detail" },
            { icon: "add", text: "Çarpan Listele", to: "/formulaMultiplier" },
            { icon: "add", text: "Çarpan Ekle", to: "/formulaMultiplier/detail" },
          ],
        },
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "Excel",
          model: true,
          children: [
            { icon: "add", text: "Excel Listele", to: "/poolOrder" },
          ],
        },
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "İndirim",
          model: true,
          children: [
            { icon: "add", text: "MP İndirim Listele", to: "/mpdiscount" },
            { icon: "add", text: "MP İndirim Ekle", to: "/mpdiscount/detail" },
          ],
        },
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "Döviz",
          model: true,
          children: [
            { icon: "add", text: "Döviz listele", to: "/priceIncrease" },
            { icon: "add", text: "Döviz Ekle", to: "/priceIncrease/detail" },
          ],
        },
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "Sigorta",
          model: true,
          children: [
            { icon: "add", text: "Sigorta listele", to: "/insurance" },
            { icon: "add", text: "Sigorta Ekle", to: "/insurance/detail" },
          ],
        },
        { icon: "settings", text: "Ayarlar", to: "/setting" },
      ];

    }
  },
  created() {
    authenticationService.currentUser.subscribe(
      (x) => {
        this.currentUser = x || {};
        this.initializeSelectors();
      }
    );
    this.loadGoldPrice();
    this.goldPriceTimer = setInterval(this.loadGoldPrice, 60000);
    this.goldPriceStaleTimer = setInterval(() => {
      this.goldPriceStaleTick = Date.now();
    }, 30000);
  },
  beforeDestroy() {
    if (this.goldPriceTimer) {
      clearInterval(this.goldPriceTimer);
      this.goldPriceTimer = null;
    }
    if (this.goldPriceStaleTimer) {
      clearInterval(this.goldPriceStaleTimer);
      this.goldPriceStaleTimer = null;
    }
  },
  methods: {
    logout() {
      authenticationService.logout();
      this.$router.push("/login");
    },
    async loadGoldPrice() {
      try {
        const res = await goldPriceApi.getGoldPrice();
        const data = res && res.data ? res.data : null;
        if (data && typeof data.price === 'number') {
          this.goldPrice = data.price;
          this.goldPriceModifiedDate = data.modifiedDate || null;
        }
      } catch (e) {
        // sessizce yut; bir sonraki tick tekrar denenecek
      }
    },
    formatGoldPrice(value) {
      if (value === null || value === undefined) return '-';
      return Number(value).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatUpdated(value) {
      if (!value) return '';
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return '';
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    initializeSelectors() {
      if (this.currentUser) {
        this.tenantOptions = this.currentUser.tenantOptions || [];
        this.marketplaceOptions = this.currentUser.marketplaceOptions || [];
        this.allTenantMarketplaces = this.currentUser.allTenantMarketplaces || [];

        // Seçili değerleri localStorage'dan al veya varsayılan değerleri ayarla
        const savedTenant = localStorage.getItem('selectedTenantId');
        const savedMp = localStorage.getItem('selectedMpId');

        this.selectedTenant = savedTenant ? parseInt(savedTenant) : this.currentUser.tenantId;

        // Marketplace'i tenant değişikliğinden sonra ayarla
        this.$nextTick(() => {
          this.selectedMarketplace = savedMp ? parseInt(savedMp) : this.currentUser.mpId;
        });

        // İlk yüklemede localStorage'a kaydet
        if (!savedTenant && this.selectedTenant) {
          localStorage.setItem('selectedTenantId', this.selectedTenant.toString());
        }
        if (!savedMp && this.selectedMarketplace) {
          localStorage.setItem('selectedMpId', this.selectedMarketplace.toString());
        }
      }
    },
    onTenantChange() {
      if (this.selectedTenant) {
        localStorage.setItem('selectedTenantId', this.selectedTenant.toString());

        // Marketplace seçimini sıfırla
        this.selectedMarketplace = null;
        localStorage.removeItem('selectedMpId');

        // İlk marketplace'i otomatik seç (opsiyonel)
        this.$nextTick(() => {
          if (this.filteredMarketplaceOptions.length > 0) {
            this.selectedMarketplace = this.filteredMarketplaceOptions[0].mpId;
            this.onMarketplaceChange();
          }
        });

        // Sayfa yenileme (isteğe bağlı)
        window.location.reload();
      }
    },
    onMarketplaceChange() {
      if (this.selectedMarketplace) {
        localStorage.setItem('selectedMpId', this.selectedMarketplace.toString());

        setTimeout(() => {
          window.location.reload();
        }, 100)
      }
    }
  }
};
</script>

<style scoped>
.gold-price-widget {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 4px 12px;
  margin-right: 12px;
}
.gold-price-icon {
  color: #6d4c00;
}
.gold-price-body {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}
.gold-price-label {
  font-size: 11px;
  color: #6d4c00;
  font-weight: 600;
  letter-spacing: 0.3px;
}
.gold-price-value {
  font-size: 15px;
  font-weight: 700;
  color: #3e2a00;
}
.gold-price-updated {
  font-size: 10px;
  color: #6d4c00;
  opacity: 0.8;
}
.gold-price-stale {
  animation: goldPriceStaleBlink 1s ease-in-out infinite;
}
.gold-price-stale .gold-price-icon,
.gold-price-stale .gold-price-label,
.gold-price-stale .gold-price-value,
.gold-price-stale .gold-price-updated {
  color: #fff !important;
  opacity: 1;
}
@keyframes goldPriceStaleBlink {
  0%, 100% {
    background: rgba(0, 0, 0, 0.08);
    box-shadow: 0 0 0 0 rgba(229, 57, 53, 0);
  }
  50% {
    background: #e53935;
    box-shadow: 0 0 10px 2px rgba(229, 57, 53, 0.7);
  }
}
</style>